import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EventIcon from "@mui/icons-material/Event";
import LiveHelpOutlinedIcon from "@mui/icons-material/LiveHelpOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CategoryIcon from "@mui/icons-material/Category";
import ViewListIcon from "@mui/icons-material/ViewList";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { Settings } from "@mui/icons-material";
const ADMIN_ROUTES = [
  {
    id: 1,
    name: "Dashboard",
    path: "/",
    activeIcon: <DashboardIcon sx={{ color: "#eb8b05" }} />,
    inActiveIcon: <DashboardIcon sx={{ color: "gray" }} />,
  },
  {
    id: 2,
    name: "Chats",
    path: "/chat",
    activeIcon: <PersonIcon sx={{ color: "#eb8b05" }} />,
    inActiveIcon: <PersonIcon sx={{ color: "gray" }} />,
  },
  {
    id: 2,
    name: "Customer",
    path: "/customer",
    activeIcon: <PersonIcon sx={{ color: "#eb8b05" }} />,
    inActiveIcon: <PersonIcon sx={{ color: "gray" }} />,
  },
  {
    id: 3,
    name: "Providers",
    path: "/providers",
    activeIcon: <AccountCircleIcon sx={{ color: "#eb8b05" }} />,
    inActiveIcon: <AccountCircleIcon sx={{ color: "gray" }} />,
  },
  {
    id: 4,
    name: "Jobs",
    path: "/jobs",
    activeIcon: <EventIcon sx={{ color: "#eb8b05" }} />,
    inActiveIcon: <EventIcon sx={{ color: "gray" }} />,
  },
  {
    id: 5,
    name: "FAQ",
    path: "/faq",
    activeIcon: <LiveHelpOutlinedIcon sx={{ color: "#eb8b05" }} />,
    inActiveIcon: <LiveHelpOutlinedIcon sx={{ color: "gray" }} />,
  },
  {
    id: 7,
    name: "Promos",
    path: "/promo",
    activeIcon: <LocalOfferIcon sx={{ color: "#eb8b05" }} />,
    inActiveIcon: <LocalOfferIcon sx={{ color: "gray" }} />,
  },
  {
    id: 6,
    name: "Notifications",
    path: "/notifications",
    activeIcon: <NotificationsIcon sx={{ color: "white" }} />,
    inActiveIcon: <NotificationsIcon sx={{ color: "gray" }} />,
  },
  // {
  //   id: 7,
  //   name: "Category",
  //   path: "/category",
  //   activeIcon: <CategoryIcon sx={{ color: "white" }} />,
  //   inActiveIcon: <CategoryIcon sx={{ color: "gray" }} />,
  // },
  {
    id: 8,
    name: "Job Title",
    path: "/job-title",
    activeIcon: <ViewListIcon sx={{ color: "white" }} />,
    inActiveIcon: <ViewListIcon sx={{ color: "gray" }} />,
  },
  {
    id: 8,
    name: "Settings",
    path: "/setting",
    activeIcon: <Settings sx={{ color: "white" }} />,
    inActiveIcon: <Settings sx={{ color: "gray" }} />,
  },
];

export default ADMIN_ROUTES;
